/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { profil_type_lvls } from './profil_type_lvls';
export type unit_option_change_model_rule = {
  id: string;
  unit_option_id: number;
  unit_id: number;
  model_rule_id: string;
  troop_id: number | null;
  action: unit_option_change_model_rule.action;
  info: string | null;
  name: string;
  description: string | null;
  type_lvl: profil_type_lvls;
  type_rule: unit_option_change_model_rule.type_rule;
  wizard_level: unit_option_change_model_rule.wizard_level;
};
export namespace unit_option_change_model_rule {
  export enum action {
    ENABLE = 'Enable',
    DISABLE = 'Disable',
  }
  export enum type_rule {
    EQUIPMENT = 'Equipment',
    SPECIAL_RULE = 'SpecialRule',
  }
  export enum wizard_level {
    NO_WIZARD = 'NoWizard',
    WIZARD = 'Wizard',
    WIZARD_APPRENTICE = 'WizardApprentice',
    WIZARD_ADEPT = 'WizardAdept',
    WIZARD_MASTER = 'WizardMaster',
  }
}
